(function () {
  function formatMoney(value, format) {
    const amount = Number(value || 0);
    const price = (amount / 100).toFixed(2);
    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/g, price).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount / 100).toString());
    }
    return `$${price}`;
  }

  function createEl(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  }

  function initBundleSection(section) {
    if (section.dataset.bundleInitialized === 'true') {
      return;
    }

    const configNode = section.querySelector('[data-bundle-config]');
    if (!configNode) {
      return;
    }

    section.dataset.bundleInitialized = 'true';

    const data = JSON.parse(configNode.textContent);

    const products = Array.isArray(data.products) ? data.products.filter(Boolean) : [];
    if (!products.length) {
      return;
    }

    const state = {
      purchaseType: 'subscribe',
      quantities: {},
      currentIndex: 0,
      nutritionOpen: false,
      showingNutritionImage: false,
      adding: false
    };

    // ---- Singles mode: exactly N single bags (one product, one variant per flavor) ----
    const SINGLES = data.mode === 'singles';
    const singlesCfg = data.singles || {};
    const BUNDLE_SIZE = Number(singlesCfg.bundleSize || 20);
    const SUBSCRIBE_AVAILABLE = !SINGLES || products.every((product) => Boolean(product.sellingPlanId));

    // ---- Free bonus bags: added as one-time lines next to the bundle (never renew) ----
    const bonusCfg = data.bonus || {};
    const BONUS_VARIANTS = Array.isArray(bonusCfg.variants) ? bonusCfg.variants : [];
    const BONUS_COUNT = BONUS_VARIANTS.length ? Number(bonusCfg.count || 0) : 0;
    const BONUS_IDS = new Set(BONUS_VARIANTS.map((v) => Number(v.id)));

    // Free bags are part of the N picked bags: the first (N - B) picks stay paid single bags,
    // the remaining B picks become the same flavors from the bonus product (free via Buy X Get Y).
    function splitPaidAndBonus(quantities) {
      const paid = {};
      const bonus = {};
      let paidLeft = Math.max(0, BUNDLE_SIZE - BONUS_COUNT);
      products.forEach((product) => {
        const qty = Number(quantities[product.blockId] || 0);
        if (!qty) return;
        const toPaid = Math.min(qty, paidLeft);
        paidLeft -= toPaid;
        if (toPaid) paid[product.blockId] = toPaid;
        const toBonus = qty - toPaid;
        if (!toBonus) return;
        const flavor = String(product.title || '').split(' 10 Pack').join('').trim().toLowerCase();
        const variant = BONUS_VARIANTS.find((v) => v.available && String(v.title).trim().toLowerCase() === flavor);
        if (variant) {
          bonus[variant.id] = (bonus[variant.id] || 0) + toBonus;
        } else {
          // No bonus variant for this flavor: keep it as a paid bag rather than dropping it
          paid[product.blockId] = (paid[product.blockId] || 0) + toBonus;
        }
      });
      return { paid: paid, bonusItems: Object.keys(bonus).map((id) => ({ id: Number(id), quantity: bonus[id] })) };
    }

    // (unused since bonus bags became part of the picked bags; kept for reference)
    function buildBonusItems() {
      if (!BONUS_COUNT) return [];
      const pool = products
        .map((product) => {
          const flavor = String(product.title || '').split(' 10 Pack').join('').trim().toLowerCase();
          return BONUS_VARIANTS.find((v) => v.available && String(v.title).trim().toLowerCase() === flavor);
        })
        .filter(Boolean);
      if (!pool.length) return [];
      const qty = {};
      for (let i = 0; i < BONUS_COUNT; i++) {
        const v = pool[i % pool.length];
        qty[v.id] = (qty[v.id] || 0) + 1;
      }
      return Object.keys(qty).map((id) => ({ id: Number(id), quantity: qty[id] }));
    }

    function prefillSingles() {
      state.quantities = {};
      const per = Math.max(0, Number(singlesCfg.defaultPerFlavor || 0));
      let left = BUNDLE_SIZE;
      products.forEach((product) => {
        if (!product.available || left <= 0 || per === 0) return;
        const qty = Math.min(per, left);
        state.quantities[product.blockId] = qty;
        left -= qty;
      });
    }

    if (SINGLES) {
      prefillSingles();
      // No subscription plan on the product yet -> start on (and stay on) one-time
      if (!SUBSCRIBE_AVAILABLE) state.purchaseType = 'onetime';
    }

    let monsterCartObserver = null;
    let monsterCartPatchQueued = false;
    let monsterCartControlsBound = false;
    let monsterCartGroupingTimeouts = [];

    const els = {
      title: section.querySelectorAll('[data-bundle-product-title]'),
      subheading: section.querySelectorAll('[data-bundle-subheading]'),
      mainImage: section.querySelector('[data-main-image]'),
      thumbs: section.querySelector('[data-gallery-thumbnails]'),
      prevArrow: section.querySelector('[data-gallery-prev]'),
      nextArrow: section.querySelector('[data-gallery-next]'),
      flavorList: section.querySelector('[data-flavor-list]'),
      progress: section.querySelector('[data-bundle-progress]'),
      steps: Array.from(section.querySelectorAll('[data-bundle-steps] .bundle-option')),
      stepPrices: Array.from(section.querySelectorAll('[data-step-price]')),
      selectionStatus: section.querySelector('[data-selection-status]'),
      subOriginal: section.querySelector('[data-sub-original]'),
      subPrice: section.querySelector('[data-sub-price]'),
      onetimePrice: section.querySelector('[data-onetime-price]'),
      cartButton: section.querySelector('[data-cart-button]'),
      cartButtonText: section.querySelector('[data-cart-button-text]'),
      cartPricing: section.querySelector('[data-cart-pricing]'),
      btnOriginal: section.querySelector('[data-btn-original]'),
      btnFinal: section.querySelector('[data-btn-final]'),
      subscribeBox: section.querySelector('[data-purchase-box="subscribe"]'),
      onetimeBox: section.querySelector('[data-purchase-box="onetime"]'),
      radioSubscribe: section.querySelector('[data-radio-subscribe]'),
      radioOnetime: section.querySelector('[data-radio-onetime]'),
      nutritionToggles: section.querySelectorAll('[data-nutrition-toggle]'),
      nutritionDropdowns: section.querySelectorAll('[data-nutrition-dropdown]'),
      nutritionIcons: section.querySelectorAll('[data-nutrition-icon]'),
      nutritionLists: section.querySelectorAll('[data-nutrition-list]'),
      nutritionImages: section.querySelectorAll('[data-nutrition-image]'),
      selectedFlavors: section.querySelectorAll('[data-selected-flavor]')
    };

    function getCartAddUrl() {
      const baseUrl = window.routes?.cart_add_url || '/cart/add';
      return baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;
    }

    function getCartUrl() {
      return window.routes?.cart_url || '/cart';
    }

    function getCartJsonUrl() {
      return `${getCartUrl()}.js`;
    }

    function getCartUpdateUrl() {
      return `${getCartUrl()}/update.js`;
    }

    function getCartChangeUrl() {
      return `${getCartUrl()}/change.js`;
    }

    const MONSTER_CART_SELECTOR = '#monster-upsell-cart';
    const MONSTER_BODY_CLASS = '_body_y9qkp_452';
    const MONSTER_INFO_CLASS = '_infos_y9qkp_392';
    const MONSTER_ROW_CLASS = '_row_y9qkp_473';
    const MONSTER_QTY_CLASS = '_qte_y9qkp_44';
    const MONSTER_CONTROL_CLASS = '_minus_y9qkp_53';
    const MONSTER_CURRENT_CLASS = '_current_y9qkp_185';
    const MONSTER_OLD_PRICE_CLASS = '_oldPrice_y9qkp_260';
    const MONSTER_LABEL_CLASS = '_label_y9qkp_50';
    const MONSTER_TITLE_CLASS = '_title_y9qkp_266';

    function isMonsterCartEnabled() {
      return Boolean(window.mu_version || window.mu_settings || window.mu_campaigns);
    }

    function updateCartBubbleMarkup(responseSections, cartState) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      const bubbleHtml = responseSections?.['cart-icon-bubble'];
      if (bubbleHtml) {
        const parsedBubble = new DOMParser()
          .parseFromString(bubbleHtml, 'text/html')
          .querySelector('.shopify-section');

        bubble.innerHTML = parsedBubble ? parsedBubble.innerHTML : bubbleHtml;
        return;
      }

      const itemCount = Number(cartState?.item_count || 0);
      bubble.innerHTML = itemCount > 0
        ? `<div class="cart-count-bubble"><span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} item${itemCount === 1 ? '' : 's'}</span></div>`
        : '';
    }

    async function fetchCartState() {
      const response = await fetch(getCartJsonUrl(), {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch updated cart state');
      }

      return response.json();
    }

    function syncMonsterCartState(cartState) {
      if (!isMonsterCartEnabled() || !cartState) return;

      window.mu_cart_items = Array.isArray(cartState.items) ? cartState.items : [];
      window.mu_cart_count = Number(cartState.item_count || 0);
      window.mu_cart_total_price = Number(cartState.total_price || 0);
      window.mu_cart_total_discount = Number(cartState.total_discount || 0);
      window.mu_cart_currency = cartState.currency || window.Shopify?.currency?.active || window.mu_cart_currency;
      window.mu_cart = cartState;
    }

    function syncMonsterCartApp(cartState) {
      if (!isMonsterCartEnabled() || !cartState) return;

      if (typeof window.monster_setCartItems === 'function') {
        window.monster_setCartItems(
          Array.isArray(cartState.items) ? cartState.items : [],
          Array.isArray(cartState.cart_level_discount_applications) ? cartState.cart_level_discount_applications : [],
          false
        );
      }
    }

    function syncMonsterCartWithRetry(cartState, attempts = 5) {
      if (!isMonsterCartEnabled() || !cartState || attempts <= 0) return;

      syncMonsterCartApp(cartState);

      if (typeof window.monster_setCartItems === 'function') {
        return;
      }

      window.setTimeout(function () {
        syncMonsterCartWithRetry(cartState, attempts - 1);
      }, 250);
    }

    function dispatchCartEvent(target, eventName, detail) {
      if (!target || typeof target.dispatchEvent !== 'function') return;
      target.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
    }

    function broadcastCartSync(cartState, responseData) {
      const detail = {
        cart: cartState,
        cartData: cartState,
        response: responseData,
        source: 'yaynuts-bundle'
      };

      if (typeof publish === 'function') {
        publish('cart-update', detail);
      }

      dispatchCartEvent(document, 'cart:updated', detail);
      dispatchCartEvent(document.documentElement, 'cart:updated', detail);
      dispatchCartEvent(window, 'cart:updated', detail);
      dispatchCartEvent(document, 'cart-update', detail);
      dispatchCartEvent(document.documentElement, 'cart-update', detail);
      dispatchCartEvent(window, 'cart-update', detail);
    }

    function openMonsterCart(cartState) {
      if (!isMonsterCartEnabled()) return;

      if (typeof window.openCart === 'function') {
        window.openCart();
        return;
      }

      const detail = {
        cart: cartState,
        cartData: cartState,
        source: 'yaynuts-bundle'
      };

      dispatchCartEvent(document, 'cart:build', detail);
      dispatchCartEvent(document.documentElement, 'cart:build', detail);
      dispatchCartEvent(window, 'cart:build', detail);
      dispatchCartEvent(document, 'cart:open', detail);
      dispatchCartEvent(document.documentElement, 'cart:open', detail);
      dispatchCartEvent(window, 'cart:open', detail);
      dispatchCartEvent(document, 'theme:drawer:open', detail);
      dispatchCartEvent(document.documentElement, 'theme:drawer:open', detail);
      dispatchCartEvent(window, 'theme:drawer:open', detail);
    }

    function openMonsterCartWithRetry(cartState, attempts = 5) {
      if (!isMonsterCartEnabled() || attempts <= 0) return;

      openMonsterCart(cartState);

      if (typeof window.openCart === 'function') {
        return;
      }

      window.setTimeout(function () {
        openMonsterCartWithRetry(cartState, attempts - 1);
      }, 250);
    }

    function sumQuantities(quantities) {
      return Object.values(quantities || {}).reduce((sum, quantity) => sum + Number(quantity || 0), 0);
    }

    function totalSelected() {
      return sumQuantities(state.quantities);
    }

    function getTierForTotal(total) {
      if (total >= 4) return 4;
      if (total >= 1) return total;
      return 1;
    }

    function selectedTier() {
      return getTierForTotal(totalSelected());
    }

    function getTierUnitPrice(tier, isSubscription) {
      const tierData = data.pricing[String(tier)];
      if (!tierData) return 1899;
      const val = isSubscription ? tierData.subscribe : tierData.regular;
      return Number(val) * 100;
    }

    // Every box in the bundle is priced at the tier for the total box count (1, 2, 3, 4+).
    function getBundleTotalPrice(quantities, isSubscription) {
      const total = sumQuantities(quantities || state.quantities);
      if (!total) return 0;
      return getTierUnitPrice(getTierForTotal(total), isSubscription) * total;
    }

    // Per-box price for the current selection (tier 1 when nothing is picked yet)
    function unitPrice(isSubscription) {
      const total = totalSelected();
      if (total === 0) return getTierUnitPrice(1, isSubscription) / 100;
      return (getBundleTotalPrice(state.quantities, isSubscription) / total) / 100;
    }

    function activePrice() {
      return unitPrice(state.purchaseType === 'subscribe');
    }

    function regularPrice() {
      return unitPrice(false);
    }

    function getItemPurchaseType(item) {
      const hasSellingPlan = Boolean(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan);
      return hasSellingPlan ? 'subscribe' : 'onetime';
    }

    function isMatchingPurchaseType(item, purchaseType) {
      const normalizedPurchaseType = purchaseType || state.purchaseType;
      return getItemPurchaseType(item) === normalizedPurchaseType;
    }

    function findProductByVariantId(variantId) {
      const normalizedVariantId = Number(variantId);

      return products.find((product) => {
        if (Number(product.variantId) === normalizedVariantId) return true;

        const tierVariants = product.tierVariants || {};
        return Object.values(tierVariants).some((id) => Number(id) === normalizedVariantId);
      }) || null;
    }

    function getBundleCartSnapshot(cartState, purchaseType) {
      const quantities = {};
      const keys = [];

      (cartState?.items || []).forEach((item) => {
        if (!isMatchingPurchaseType(item, purchaseType)) return;

        const product = findProductByVariantId(item.variant_id || item.id);
        if (!product) return;

        quantities[product.blockId] = (quantities[product.blockId] || 0) + Number(item.quantity || 0);
        keys.push(item.key);
      });

      return {
        quantities: quantities,
        keys: keys
      };
    }

    function getBundleCartGroups(cartState, purchaseType) {
      const groups = [];
      const groupMap = new Map();

      (cartState?.items || []).forEach((item, index) => {
        if (purchaseType && !isMatchingPurchaseType(item, purchaseType)) return;

        const product = findProductByVariantId(item.variant_id || item.id);
        if (!product) return;

        const itemPurchaseType = getItemPurchaseType(item);
        const groupKey = `${product.blockId}::${itemPurchaseType}`;
        let group = groupMap.get(groupKey);

        if (!group) {
          group = {
            key: groupKey,
            blockId: product.blockId,
            product: product,
            purchaseType: itemPurchaseType,
            quantity: 0,
            currentPrice: 0,
            originalPrice: 0,
            itemIndexes: []
          };

          groupMap.set(groupKey, group);
          groups.push(group);
        }

        group.quantity += Number(item.quantity || 0);
        group.currentPrice += Number(item.final_line_price ?? item.line_price ?? 0);
        group.originalPrice += Number(item.original_line_price ?? item.final_line_price ?? item.line_price ?? 0);
        group.itemIndexes.push(index);
      });

      return groups;
    }

    function buildBundleItems(quantities, purchaseType) {
      const items = [];

      products.forEach((product) => {
        const quantity = Number(quantities[product.blockId] || 0);
        if (!quantity) return;

        const variantId = product.variantId || product.variants?.[0]?.id;
        if (!variantId) return;

        const item = {
          id: Number(variantId),
          quantity: quantity
        };

        if (purchaseType === 'subscribe') {
          // Never fall back to a one-time line when the shopper chose Subscribe & Save,
          // or they'd be charged the one-time price with no subscription.
          if (!product.sellingPlanId) {
            throw new Error(`No subscription plan for ${product.title}`);
          }
          item.selling_plan = Number(product.sellingPlanId);
        }

        items.push(item);
      });

      return items;
    }

    // Removes every cart line of the given bundle lines' variants in ONE /cart/update.js call.
    // Removing line-by-line by key breaks when automatic discounts (e.g. Buy X Get Y) re-split
    // and re-key lines after each change, so we match by variant id and retry if lines remain.
    async function clearExistingBundleItems(keys) {
      const wanted = Array.from(new Set((keys || []).filter(Boolean)));
      if (!wanted.length) return;

      // Line keys look like "<variantId>:<hash>" - the variant id survives re-keying
      const variantIds = new Set(wanted.map((key) => Number(String(key).split(':')[0])).filter(Boolean));
      const updateUrl = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/update.js`;
      let cart = await fetchCartState();

      for (let attempt = 0; attempt < 3; attempt++) {
        const remaining = (cart.items || []).some((item) => variantIds.has(Number(item.variant_id)));
        if (!remaining) return;

        const updates = (cart.items || []).map((item) => (variantIds.has(Number(item.variant_id)) ? 0 : item.quantity));
        const response = await fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: updates })
        });
        if (!response.ok) throw new Error('Failed to clear existing bundle items');
        cart = await response.json();
      }

      if ((cart.items || []).some((item) => variantIds.has(Number(item.variant_id)))) {
        throw new Error('Failed to clear existing bundle items');
      }
    }

    function getCartContainer() {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = isMonsterCartEnabled() ? null : document.querySelector('cart-notification');

      return {
        cartDrawer: cartDrawer,
        cartNotification: cartNotification,
        cart: cartDrawer || cartNotification
      };
    }

    function renderThemeCart(cart, cartDrawer, cartNotification, responseData) {
      if (!cart || isMonsterCartEnabled()) return;

      if (cartNotification && responseData.key) {
        cartNotification.cartItemKey = responseData.key;
      }

      const isCollectionPage = window.location.pathname.includes('/collections/');
      if (typeof cart.renderContents === 'function' && !isCollectionPage) {
        cart.renderContents(responseData);
        return;
      }

      cart.classList.remove('is-empty');

      if (typeof cart.open === 'function') {
        cart.open();
      } else {
        cart.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }

    function getMonsterCartBody() {
      return document.querySelector(`${MONSTER_CART_SELECTOR} .${MONSTER_BODY_CLASS}`) || document.querySelector(MONSTER_CART_SELECTOR);
    }

    function hasMonsterClass(node, className) {
      return Boolean(node && node.classList && node.classList.contains(className));
    }

    function getMonsterCartBlocks() {
      const body = getMonsterCartBody();
      if (!body) return [];

      const infoNodes = Array.from(body.querySelectorAll(`.${MONSTER_INFO_CLASS}`)).filter(function (node) {
        return node instanceof Element && node.closest(`.${MONSTER_BODY_CLASS}`) === body;
      });

      if (infoNodes.length > 0) {
        return infoNodes.map(function (infoNode) {
          const rowNodes = [];
          let sibling = infoNode.nextElementSibling;

          while (sibling && !hasMonsterClass(sibling, MONSTER_INFO_CLASS)) {
            if (hasMonsterClass(sibling, MONSTER_ROW_CLASS)) {
              rowNodes.push(sibling);
            }
            sibling = sibling.nextElementSibling;
          }

          return {
            infoNode: infoNode,
            rowNodes: rowNodes
          };
        });
      }

      const blocks = [];
      let currentBlock = null;

      const nodes = Array.from(body.querySelectorAll(`.${MONSTER_INFO_CLASS}, .${MONSTER_ROW_CLASS}`));

      nodes.forEach((child) => {
        if (!(child instanceof Element)) return;

        if (hasMonsterClass(child, MONSTER_INFO_CLASS)) {
          currentBlock = {
            infoNode: child,
            rowNodes: []
          };

          blocks.push(currentBlock);
          return;
        }

        if (hasMonsterClass(child, MONSTER_ROW_CLASS) && currentBlock) {
          currentBlock.rowNodes.push(child);
        }
      });

      return blocks;
    }

    function resetMonsterCartBlock(block) {
      if (!block) return;

      block.infoNode.style.display = '';
      block.infoNode.removeAttribute('data-yaynuts-group-key');
      block.infoNode.removeAttribute('data-yaynuts-group-product');
      block.infoNode.removeAttribute('data-yaynuts-group-purchase-type');

      block.rowNodes.forEach((row) => {
        row.style.display = '';
        row.style.pointerEvents = '';
        row.removeAttribute('data-yaynuts-group-key');
        row.removeAttribute('data-yaynuts-group-product');
        row.removeAttribute('data-yaynuts-group-purchase-type');

        const input = row.querySelector('input[type="number"]');
        if (input) {
          input.readOnly = false;
        }
      });
    }

    function normalizeMonsterText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function getMonsterBlockTitle(block) {
      if (!block || !block.infoNode) return '';

      const titleNode = block.infoNode.querySelector(`.${MONSTER_TITLE_CLASS}`);
      return normalizeMonsterText(titleNode ? titleNode.textContent : block.infoNode.textContent);
    }

    function getMonsterBlocksByTitle() {
      const blocks = getMonsterCartBlocks();
      const groupedBlocks = new Map();

      blocks.forEach(function (block, index) {
        const title = getMonsterBlockTitle(block);
        if (!title) return;

        if (!groupedBlocks.has(title)) {
          groupedBlocks.set(title, []);
        }

        groupedBlocks.get(title).push({
          index: index,
          block: block
        });
      });

      return groupedBlocks;
    }

    function setMonsterCartBlockHidden(block) {
      if (!block) return;

      block.infoNode.style.display = 'none';
      block.rowNodes.forEach((row) => {
        row.style.display = 'none';
      });
    }

    function patchMonsterCartGroupBlock(block, group) {
      if (!block) return;

      block.infoNode.setAttribute('data-yaynuts-group-key', group.key);
      block.infoNode.setAttribute('data-yaynuts-group-product', group.blockId);
      block.infoNode.setAttribute('data-yaynuts-group-purchase-type', group.purchaseType);

      const currentPriceNode = block.infoNode.querySelector(`.${MONSTER_CURRENT_CLASS}`);
      if (currentPriceNode) {
        currentPriceNode.innerHTML = formatMoney(group.currentPrice, data.moneyFormat);
      }

      const oldPriceNode = block.infoNode.querySelector(`.${MONSTER_OLD_PRICE_CLASS}`);
      if (oldPriceNode) {
        if (group.originalPrice > group.currentPrice) {
          oldPriceNode.innerHTML = formatMoney(group.originalPrice, data.moneyFormat);
          oldPriceNode.style.display = '';
        } else {
          oldPriceNode.style.display = 'none';
        }
      }

      let quantityRow = null;
      let variantRow = null;

      block.rowNodes.forEach((row) => {
        row.setAttribute('data-yaynuts-group-key', group.key);
        row.setAttribute('data-yaynuts-group-product', group.blockId);
        row.setAttribute('data-yaynuts-group-purchase-type', group.purchaseType);

        if (!quantityRow && row.querySelector('input[type="number"]')) {
          quantityRow = row;
        }

        if (!variantRow && row.querySelector(`.${MONSTER_CURRENT_CLASS}`)) {
          variantRow = row;
        }
      });

      if (quantityRow) {
        const input = quantityRow.querySelector('input[type="number"]');
        if (input) {
          input.value = String(group.quantity);
          input.setAttribute('value', String(group.quantity));
          input.readOnly = true;
        }
      }

      if (variantRow) {
        const labelNode = variantRow.querySelector(`.${MONSTER_LABEL_CLASS}`);
        if (labelNode) {
          labelNode.textContent = 'Bundle Size';
        }

        const currentNode = variantRow.querySelector(`.${MONSTER_CURRENT_CLASS}`);
        if (currentNode) {
          currentNode.textContent = `${group.quantity} ${group.quantity === 1 ? 'Bag' : 'Bags'}`;
        }

        variantRow.style.pointerEvents = 'none';
      }
    }

    function applyMonsterCartGrouping() {
      monsterCartPatchQueued = false;

      if (!isMonsterCartEnabled()) return;

      const cartState = window.mu_cart;
      if (!cartState || !Array.isArray(cartState.items) || cartState.items.length === 0) return;

      const blocks = getMonsterCartBlocks();
      if (!blocks.length) return;

      blocks.forEach(resetMonsterCartBlock);

      const groups = getBundleCartGroups(cartState);
      if (!groups.length) return;
      const groupsByTitle = new Map();
      const blocksByTitle = getMonsterBlocksByTitle();

      groups.forEach(function (group) {
        const title = normalizeMonsterText(group.product?.title);
        if (!title) return;

        const existing = groupsByTitle.get(title);
        if (!existing) {
          groupsByTitle.set(title, Object.assign({}, group));
          return;
        }

        existing.quantity += group.quantity;
        existing.currentPrice += group.currentPrice;
        existing.originalPrice += group.originalPrice;
        existing.itemIndexes = existing.itemIndexes.concat(group.itemIndexes);
      });

      groupsByTitle.forEach(function (group, title) {
        const matchingBlocks = blocksByTitle.get(title) || [];
        if (!matchingBlocks.length) return;

        patchMonsterCartGroupBlock(matchingBlocks[0].block, group);

        matchingBlocks.slice(1).forEach(function (entry) {
          setMonsterCartBlockHidden(entry.block);
        });
      });
    }

    function queueMonsterCartGrouping() {
      if (!isMonsterCartEnabled() || monsterCartPatchQueued) return;

      monsterCartPatchQueued = true;
      window.requestAnimationFrame(applyMonsterCartGrouping);
    }

    function scheduleMonsterCartGrouping() {
      if (!isMonsterCartEnabled()) return;

      monsterCartGroupingTimeouts.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });
      monsterCartGroupingTimeouts = [];

      queueMonsterCartGrouping();

      [80, 180, 320, 500, 800, 1200].forEach(function (delay) {
        const timeoutId = window.setTimeout(queueMonsterCartGrouping, delay);
        monsterCartGroupingTimeouts.push(timeoutId);
      });
    }

    function bindMonsterCartGroupingEvents() {
      if (!isMonsterCartEnabled()) return;

      ['cart:updated', 'cart-update', 'cart:open', 'theme:drawer:open'].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleMonsterCartGrouping);
        window.addEventListener(eventName, scheduleMonsterCartGrouping);
      });
    }

    function observeMonsterCart() {
      if (!isMonsterCartEnabled() || monsterCartObserver) return;

      monsterCartObserver = new MutationObserver(function () {
        queueMonsterCartGrouping();
      });

      monsterCartObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      scheduleMonsterCartGrouping();
    }

    // options.openCart = false: update the cart without opening the cart drawer (used before
    // sending the shopper straight to checkout).
    async function rebuildBundleCart(quantities, purchaseType, options) {
      const openCart = !options || options.openCart !== false;
      const normalizedPurchaseType = purchaseType || state.purchaseType;
      const { cartDrawer, cartNotification, cart } = getCartContainer();
      const currentCartState = await fetchCartState();
      const existingBundle = getBundleCartSnapshot(currentCartState, normalizedPurchaseType);
      const items = buildBundleItems(quantities, normalizedPurchaseType);

      if (existingBundle.keys.length > 0) {
        await clearExistingBundleItems(existingBundle.keys);
      }

      let responseData = {
        items: [],
        sections: {}
      };

      if (items.length > 0) {
        const formData = new FormData();

        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
          if (item.selling_plan) {
            formData.append(`items[${index}][selling_plan]`, item.selling_plan);
          }
        });

        if (cart) {
          const sections = cartDrawer
            ? ['cart-drawer', 'cart-icon-bubble']
            : ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to update bundle cart');
        }

        responseData = await response.json();

        if (responseData.items && responseData.items.length > 0) {
          responseData.key = responseData.items[0].key;
        }
      }

      const cartState = await fetchCartState();

      updateCartBubbleMarkup(responseData.sections, cartState);
      syncMonsterCartState(cartState);
      syncMonsterCartWithRetry(cartState);
      broadcastCartSync(cartState, responseData);
      if (openCart) {
        renderThemeCart(cart, cartDrawer, cartNotification, responseData);
        openMonsterCartWithRetry(cartState);
        scheduleMonsterCartGrouping();
      }

      return {
        cartState: cartState,
        responseData: responseData
      };
    }

    function parseGroupKey(groupKey) {
      const keyParts = String(groupKey || '').split('::');
      return {
        blockId: keyParts[0] || '',
        purchaseType: keyParts[1] || 'onetime'
      };
    }

    async function updateGroupedBundleQuantity(groupKey, delta) {
      const parsed = parseGroupKey(groupKey);
      if (!parsed.blockId || !delta) return;

      const currentCartState = await fetchCartState();
      const snapshot = getBundleCartSnapshot(currentCartState, parsed.purchaseType);
      const nextQuantities = Object.assign({}, snapshot.quantities);
      const currentQuantity = Number(nextQuantities[parsed.blockId] || 0);
      const nextQuantity = Math.max(0, currentQuantity + delta);

      if (nextQuantity === currentQuantity) return;

      if (nextQuantity === 0) {
        delete nextQuantities[parsed.blockId];
      } else {
        nextQuantities[parsed.blockId] = nextQuantity;
      }

      if (delta > 0 && sumQuantities(nextQuantities) > Number(data.config.maxBags || 4)) {
        return;
      }

      await rebuildBundleCart(nextQuantities, parsed.purchaseType);
    }

    function bindMonsterCartControls() {
      if (!isMonsterCartEnabled() || monsterCartControlsBound) return;

      document.addEventListener('click', function (event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const groupedRow = target.closest(`.${MONSTER_ROW_CLASS}[data-yaynuts-group-key]`);
        const groupedInfo = target.closest(`.${MONSTER_INFO_CLASS}[data-yaynuts-group-key]`);

        if (groupedRow) {
          const control = target.closest(`.${MONSTER_CONTROL_CLASS}`);
          if (!control) return;

          const delta = control.textContent && control.textContent.trim() === '+' ? 1 : -1;
          const groupKey = groupedRow.getAttribute('data-yaynuts-group-key');
          if (!groupKey) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          updateGroupedBundleQuantity(groupKey, delta).catch(function () {});
          return;
        }

        if (groupedInfo && target.closest('svg, path, use, button')) {
          const groupKey = groupedInfo.getAttribute('data-yaynuts-group-key');
          if (!groupKey) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          updateGroupedBundleQuantity(groupKey, -999).catch(function () {});
        }
      }, true);

      monsterCartControlsBound = true;
    }

    function updateHeader() {
      const current = products[state.currentIndex] || products[0];
      els.title.forEach((node) => {
        node.textContent = current.title;
      });
    }

    function renderGallery() {
      const current = products[state.currentIndex] || products[0];

      if (els.mainImage) {
        els.mainImage.src = current.galleryImage || current.featuredImage;
        els.mainImage.alt = current.title;
      }

      updateHeader();
    }

    function showPreviousImage() {
      state.currentIndex = (state.currentIndex - 1 + products.length) % products.length;
      renderGallery();
    }

    function showNextImage() {
      state.currentIndex = (state.currentIndex + 1) % products.length;
      renderGallery();
    }

    function renderNutritionList() {
      if (els.nutritionLists.length === 0) return;

      els.nutritionLists.forEach(list => {
        list.innerHTML = '';
        staticFlavors.forEach((product) => {
          const item = createEl('button', 'flavor-item flex w-full items-center gap-3 p-3 hover:bg-gray-100 cursor-pointer');
          item.type = 'button';
          item.innerHTML = `<img src="${getFlavorImage(product)}" class="w-10 h-10 rounded object-cover" style="background-color: ${product.color || '#f3f4f6'};" alt="${product.title}"><span>${product.title}</span>`;
          item.addEventListener('click', function () {
            applyNutritionFlavor(product);
            // Close just this flavor's own dropdown list, not every nutrition panel on the page
            list.classList.add('hidden');
          });
          list.appendChild(item);
        });
      });

      if (staticFlavors.length > 0) applyNutritionFlavor(staticFlavors[0]);
    }

    function applyNutritionFlavor(product) {
      document.querySelectorAll('[data-nutrition-flavor-label]').forEach(label => {
        label.textContent = product.title;
      });
      els.nutritionImages.forEach(ni => {
        ni.src = getFlavorImage(product);
        ni.alt = product.title;
      });
      const n = product.nutrition;
      if (n) {
        const setAll = (selector, value) => {
          document.querySelectorAll(selector).forEach(el => { el.textContent = value; });
        };
        setAll('[data-nutrition-servings-per]', n.servingsPer);
        setAll('[data-nutrition-serving-size]', n.servingSize);
        setAll('[data-nutrition-calories]', n.calories);
        setAll('[data-nutrition-fat]', n.fat);
        setAll('[data-nutrition-fat-pct]', n.fatPct);
        setAll('[data-nutrition-satfat]', n.satfat);
        setAll('[data-nutrition-satfat-pct]', n.satfatPct);
        setAll('[data-nutrition-cholesterol]', n.cholesterol);
        setAll('[data-nutrition-cholesterol-pct]', n.cholesterolPct);
        setAll('[data-nutrition-sodium]', n.sodium);
        setAll('[data-nutrition-sodium-pct]', n.sodiumPct);
        setAll('[data-nutrition-carbs]', n.carbs);
        setAll('[data-nutrition-carbs-pct]', n.carbsPct);
        setAll('[data-nutrition-fiber]', n.fiber);
        setAll('[data-nutrition-fiber-pct]', n.fiberPct);
        setAll('[data-nutrition-sugars]', n.sugars);
        setAll('[data-nutrition-protein]', n.protein);
        setAll('[data-nutrition-transfat]', n.transFat);
        setAll('[data-nutrition-added-sugars]', n.addedSugars);
        setAll('[data-nutrition-added-sugars-pct]', n.addedSugarsPct);
        setAll('[data-nutrition-vitamin-d]', n.vitaminD);
        setAll('[data-nutrition-vitamin-d-pct]', n.vitaminDPct);
        setAll('[data-nutrition-calcium]', n.calcium);
        setAll('[data-nutrition-calcium-pct]', n.calciumPct);
        setAll('[data-nutrition-iron]', n.iron);
        setAll('[data-nutrition-iron-pct]', n.ironPct);
        setAll('[data-nutrition-potassium]', n.potassium);
        setAll('[data-nutrition-potassium-pct]', n.potassiumPct);
      }
      if (product.color) {
        document.querySelectorAll('[data-nutrition-panel]').forEach(panel => { panel.style.backgroundColor = product.color; });
      }
      const ingredients = product.ingredients || '';
      document.querySelectorAll('[data-nutrition-ingredients]').forEach(el => { el.textContent = ingredients; });
      document.querySelectorAll('[data-nutrition-ingredients-wrap]').forEach(el => { el.classList.toggle('hidden', !ingredients); });
    }

    var staticFlavors = [
      { handle: 'sabor-fuego-cashews-10-pack', title: 'Fuego Cashews', color: '#C12B25', ingredients: 'Cashews, Sugar, Honey, Avocado Oil, Chili Powder, Cayenne Pepper, Salt, Dehydrated Onion, Garlic Powder.', description: 'Chili-lime zing with a fiery kick.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Sabor-Fuego-Cashews.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 150, fat: '12g', fatPct: '15%', satfat: '2.5g', satfatPct: '13%', transFat: '0g', cholesterol: '0mg', cholesterolPct: '0%', sodium: '150mg', sodiumPct: '7%', carbs: '9g', carbsPct: '3%', fiber: '1g', fiberPct: '4%', sugars: '2g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '20mg', calciumPct: '2%', iron: '1.7mg', ironPct: '10%', potassium: '160mg', potassiumPct: '4%' } },
      { handle: 'hot-honey-cashews-10-pack', title: 'Hot Honey Cashews', color: '#D85E1F', ingredients: 'Cashews, Sugar, Honey, Avocado Oil, Chili Powder, Cayenne Pepper, Salt, Dehydrated Onion, Garlic Powder.', description: 'Sweet honey with a peppery finish.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Hot-Honey-Cashews.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 100, fat: '7g', fatPct: '9%', satfat: '1g', satfatPct: '5%', transFat: '0g', cholesterol: '0mg', cholesterolPct: '0%', sodium: '35mg', sodiumPct: '2%', carbs: '9g', carbsPct: '3%', fiber: '<1g', fiberPct: '2%', sugars: '5g', addedSugars: '4g', addedSugarsPct: '8%', protein: '3g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '0%', iron: '1mg', ironPct: '6%', potassium: '100mg', potassiumPct: '2%' } },
      { handle: 'honey-roasted-bbq-cashews-10-pack', title: 'Honey Roasted BBQ Cashews', color: '#972C20', ingredients: 'Roasted Cashews, Honey, Tomato Paste (Vine-Ripened Fresh Tomatoes and Naturally Derived Citric Acid), Paprika, Avocado Oil, Apple Cider Vinegar, Brown Sugar, Garlic Powder, Sea Salt, Ground Sumac, Onion Powder, Natural Hickory Smoke Flavor, Mustard Powder, Black Pepper, Celery, Celery Seed.', description: 'Honey sweetness meets smoky, tangy BBQ.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Hot-Honey-BBQ-Cashews.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 140, fat: '10g', fatPct: '13%', satfat: '2g', satfatPct: '10%', transFat: '0g', cholesterol: '0mg', cholesterolPct: '0%', sodium: '160mg', sodiumPct: '7%', carbs: '9g', carbsPct: '3%', fiber: '<1g', fiberPct: '3%', sugars: '3g', addedSugars: '2g', addedSugarsPct: '4%', protein: '3g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '2%', iron: '1.4mg', ironPct: '8%', potassium: '130mg', potassiumPct: '2%' } },
      { handle: 'cool-ranch-cashews-10-pack', title: 'Ranch Cashews', color: '#3EA7CE', ingredients: 'Cashews, Buttermilk Powder, Butter (Cream, Salt), Avocado Oil, Garlic Powder, Onion Powder, Nutritional Yeast Flakes, Arabic Gum, Sea Salt, Sugar, Chives, Citric Acid, Black Pepper, Ground Parsley, Dill Seed.', description: 'Buttermilk, garlic, and herbs in every crunch.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Ranch-Cashews.jpg?v=1790616191',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 150, fat: '12g', fatPct: '15%', satfat: '3g', satfatPct: '15%', transFat: '0g', cholesterol: '<5mg', cholesterolPct: '2%', sodium: '100mg', sodiumPct: '4%', carbs: '9g', carbsPct: '3%', fiber: '<1g', fiberPct: '3%', sugars: '2g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '40mg', calciumPct: '2%', iron: '1.4mg', ironPct: '8%', potassium: '170mg', potassiumPct: '4%' } },
      { handle: 'dill-pickle-cashews-10-pack', title: 'Dill Pickle Cashews', color: '#34571E', ingredients: 'Roasted Cashews, Avocado Oil, Salt, Garlic Powder, Dill, Sugar, Arabic Gum, Dehydrated Onion, Lactic Acid, Mustard Seed, Celery, Lemon Juice, Citric Acid, Caraway Seed, White Pepper, Turmeric.', description: 'Big pickle tang with garlic and dill.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Dill-Pickle-Cashews.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 150, fat: '12g', fatPct: '15%', satfat: '2.5g', satfatPct: '13%', transFat: '0g', cholesterol: '0mg', cholesterolPct: '0%', sodium: '160mg', sodiumPct: '7%', carbs: '9g', carbsPct: '3%', fiber: '<1g', fiberPct: '3%', sugars: '2g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '20mg', calciumPct: '2%', iron: '1.6mg', ironPct: '10%', potassium: '160mg', potassiumPct: '4%' } },
      { handle: 'roasted-salted-cashews-10-pack', title: 'Roasted & Salted Cashews', color: '#E6BF51', ingredients: 'Cashews, Avocado Oil, Sea Salt.', description: 'Roasted cashews. Avocado oil. Sea salt.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Butter-Toffee-Cashews-Roasted-salted.jpg?v=1790616191',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 160, fat: '13g', fatPct: '17%', satfat: '2g', satfatPct: '10%', transFat: '0g', cholesterol: '0mg', cholesterolPct: '0%', sodium: '120mg', sodiumPct: '5%', carbs: '8g', carbsPct: '3%', fiber: '<1g', fiberPct: '3%', sugars: '2g', addedSugars: '0g', addedSugarsPct: '0%', protein: '5g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '0%', iron: '1.8mg', ironPct: '10%', potassium: '180mg', potassiumPct: '4%' } },
      { handle: 'butter-toffee-cashews-10-pack', title: 'Butter Toffee Cashews', color: '#C7C74C', ingredients: 'Cashews, Sugar, Butter (Cream, Salt).', description: 'Buttery toffee wrapped around a rich cashew crunch.', image: '',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 150, fat: '10g', fatPct: '13%', satfat: '2.5g', satfatPct: '13%', transFat: '0g', cholesterol: '<5mg', cholesterolPct: '1%', sodium: '60mg', sodiumPct: '3%', carbs: '12g', carbsPct: '4%', fiber: '<1g', fiberPct: '2%', sugars: '7g', addedSugars: '6g', addedSugarsPct: '12%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '0%', iron: '1.4mg', ironPct: '8%', potassium: '140mg', potassiumPct: '2%' } },
      { handle: 'butter-toffee-pecans-10-pack', title: 'Butter Toffee Pecans', color: '#7275B8', ingredients: 'Pecans, Sugar, Butter (Cream, Salt).', description: 'Delicate pecans with a crisp, sweet toffee coating.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Butter-Toffee-Pecans.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 160, fat: '12g', fatPct: '15%', satfat: '1.5g', satfatPct: '8%', transFat: '0g', cholesterol: '<5mg', cholesterolPct: '1%', sodium: '5mg', sodiumPct: '0%', carbs: '14g', carbsPct: '5%', fiber: '1g', fiberPct: '4%', sugars: '12g', addedSugars: '12g', addedSugarsPct: '24%', protein: '1g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '0%', iron: '0.4mg', ironPct: '2%', potassium: '60mg', potassiumPct: '2%' } },
      { handle: 'butter-toffee-almonds-10-pack', title: 'Butter Toffee Almonds', color: '#CF4151', ingredients: 'Almonds, Sugar, Butter (Cream, Salt).', description: 'A firm almond crunch with a buttery toffee shell.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Butter-Toffee-Almonds.jpg?v=1790616191',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 150, fat: '10g', fatPct: '13%', satfat: '1g', satfatPct: '5%', transFat: '0g', cholesterol: '<5mg', cholesterolPct: '1%', sodium: '5mg', sodiumPct: '0%', carbs: '13g', carbsPct: '5%', fiber: '2g', fiberPct: '7%', sugars: '10g', addedSugars: '9g', addedSugarsPct: '18%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '50mg', calciumPct: '4%', iron: '0.7mg', ironPct: '4%', potassium: '130mg', potassiumPct: '2%' } },
      { handle: 'butter-toffee-peanuts-10-pack', title: 'Butter Toffee Peanuts', color: '#49C2BD', ingredients: 'Peanuts, Sugar, Butter (Cream, Salt).', description: 'Classic sweet-and-salty crunch with a toffee twist.', image: 'https://cdn.shopify.com/s/files/1/0606/7411/3601/files/Butter-Toffee-Peanuts.jpg?v=1790616190',
        nutrition: { servingsPer: '1 serving per container', servingSize: '1 Pack (28g)', calories: 140, fat: '9g', fatPct: '12%', satfat: '1.5g', satfatPct: '8%', transFat: '0g', cholesterol: '<5mg', cholesterolPct: '1%', sodium: '10mg', sodiumPct: '0%', carbs: '14g', carbsPct: '5%', fiber: '1g', fiberPct: '4%', sugars: '12g', addedSugars: '11g', addedSugarsPct: '22%', protein: '4g', vitaminD: '0mcg', vitaminDPct: '0%', calcium: '10mg', calciumPct: '2%', iron: '0.7mg', ironPct: '4%', potassium: '110mg', potassiumPct: '2%' } }
    ];

    // Flavor photo: the curated square photo when there is one, otherwise the real product's
    // photo (a transparent pack cut-out, so it sits on the flavor's color).
    function getFlavorImage(flavor) {
      if (flavor.image) return flavor.image;
      const product = products.find((p) => p.handle === flavor.handle);
      return product ? product.featuredImage : '';
    }

    function getFlavorMeta(product) {
      return staticFlavors.find((flavor) => flavor.handle === product.handle) || null;
    }

    function renderFlavors() {
      if (!els.flavorList) return;
      els.flavorList.innerHTML = '';

      const maxReached = totalSelected() >= Number(data.config.maxBags || 10);
      const buttonClass = 'bg-[#0277B6] text-white border-2 border-[#014465] shadow-[2px_2px_0px_0px_#014465] w-[73px] h-[28px] md:w-[100px] md:h-[36px] rounded-full font-extrabold uppercase text-[10px] sm:text-[11px] md:text-sm';

      products.forEach((product, index) => {
        const meta = getFlavorMeta(product);
        const title = meta ? meta.title : product.title;
        const description = meta ? meta.description : (product.description || '');
        const image = meta ? getFlavorImage(meta) : product.featuredImage;
        const imageBg = (meta && meta.color) || '#f3f4f6';
        const quantity = Number(state.quantities[product.blockId] || 0);
        const isLast = index === products.length - 1;

        const card = createEl('div', `bg-white py-1.5 px-2 md:p-4 overflow-hidden flex items-center gap-3 md:gap-4 ${isLast ? '' : 'border-b-2 border-black'}`);
        card.style.minHeight = '0';

        let control;
        if (!product.available) {
          control = `<button type="button" disabled class="${buttonClass} opacity-50 cursor-not-allowed">Sold out</button>`;
        } else if (quantity > 0) {
          control = `
            <div class="${buttonClass} flex items-center justify-between px-1">
              <button type="button" data-flavor-minus="${product.blockId}" class="w-6 h-full cursor-pointer" aria-label="Remove one ${title}">&minus;</button>
              <span>${quantity}</span>
              <button type="button" data-flavor-plus="${product.blockId}" class="w-6 h-full ${maxReached ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}" ${maxReached ? 'disabled' : ''} aria-label="Add one ${title}">+</button>
            </div>`;
        } else {
          control = `<button type="button" data-flavor-plus="${product.blockId}" ${maxReached ? 'disabled' : ''} class="${buttonClass} ${maxReached ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-95'}">Add</button>`;
        }

        card.innerHTML = `
          <div class="relative rounded-xl overflow-hidden flex-shrink-0 box-border w-[60px] h-[60px] md:w-[80px] md:h-[80px]" style="background-color: ${imageBg};">
            <img src="${image}" alt="${title}" class="w-full h-full object-cover">
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="font-extrabold uppercase text-[12px] sm:text-[14px] md:text-[15px] lg:text-[17px] xl:text-[17px] text-black">${title}</h4>
            <p class="text-[8px] sm:text-[10px] md:text-[12px] lg:text-[13px] xl:text-[13px] text-gray-500">${description}</p>
          </div>
          <div class="flex items-center gap-2 pr-1">${control}</div>
        `;

        els.flavorList.appendChild(card);
      });
    }

    function changeFlavorQuantity(blockId, delta) {
      const current = Number(state.quantities[blockId] || 0);
      const next = Math.max(0, current + delta);
      if (delta > 0 && totalSelected() >= Number(data.config.maxBags || 10)) return;

      if (next === 0) {
        delete state.quantities[blockId];
      } else {
        state.quantities[blockId] = next;
      }
      refresh();
    }

    if (els.flavorList) {
      els.flavorList.addEventListener('click', function (event) {
        const plus = event.target.closest('[data-flavor-plus]');
        const minus = event.target.closest('[data-flavor-minus]');
        if (plus && !plus.disabled) changeFlavorQuantity(plus.getAttribute('data-flavor-plus'), 1);
        if (minus) changeFlavorQuantity(minus.getAttribute('data-flavor-minus'), -1);
      });
    }

    function updateProgress() {
      const total = totalSelected();
      const progress = Math.min((total / Number(data.config.progressTarget || 1)) * 100, 100);
      if (els.progress) {
        els.progress.style.width = `${progress}%`;
        // Ensure the progress bar has proper styling
        els.progress.style.height = '100%';
        els.progress.style.backgroundColor = '#056A9B'; // Use the exact color from CSS
        els.progress.style.display = 'block';
        els.progress.style.visibility = 'visible';
        els.progress.style.opacity = '1';
        els.progress.style.minWidth = '0%';
        els.progress.style.maxWidth = '100%';
        els.progress.style.position = 'relative';
      }

      if (SINGLES) {
        const countEl = section.querySelector('[data-singles-count]');
        const hintEl = section.querySelector('[data-singles-hint]');
        if (countEl) countEl.textContent = total;
        if (hintEl) {
          const remaining = BUNDLE_SIZE - total;
          hintEl.textContent = remaining > 0
            ? `Add ${remaining} more bag${remaining === 1 ? '' : 's'}`
            : (data.texts.selectionComplete || 'Bundle complete!');
        }
      }

      els.steps.forEach((step, index) => {
        const active = total >= index + 1;
        // Find the circle element by looking for the div with border classes
        const circle = step.querySelector('div[class*="border-primary"]') ||
                      step.querySelector('div[class*="border-gray-300"]') ||
                      step.querySelector('div.rounded-full');
        const dot = step.querySelector('.dot');
        if (circle) {
          circle.classList.toggle('border-primary', active);
          circle.classList.toggle('border-gray-300', !active);
        }
        if (dot) {
          dot.classList.toggle('bg-primary', active);
          dot.classList.toggle('bg-transparent', !active);
        }
      });
    }

    function updatePurchaseBoxes() {
      if (SINGLES && els.subscribeBox) {
        els.subscribeBox.classList.toggle('opacity-50', !SUBSCRIBE_AVAILABLE);
        els.subscribeBox.classList.toggle('cursor-not-allowed', !SUBSCRIBE_AVAILABLE);
        els.subscribeBox.setAttribute('aria-disabled', String(!SUBSCRIBE_AVAILABLE));
      }
      const subscribeActive = state.purchaseType === 'subscribe';
      if (els.radioSubscribe) els.radioSubscribe.checked = subscribeActive;
      if (els.radioOnetime) els.radioOnetime.checked = !subscribeActive;
      if (els.subscribeBox) {
        els.subscribeBox.classList.toggle('border-primary', subscribeActive);
        els.subscribeBox.classList.toggle('shadow-xl', subscribeActive);
      }
      if (els.onetimeBox) {
        els.onetimeBox.classList.toggle('border-primary', !subscribeActive);
        els.onetimeBox.classList.toggle('bg-white', !subscribeActive);
        els.onetimeBox.classList.toggle('border-gray-200', subscribeActive);
        els.onetimeBox.classList.toggle('bg-gray-50', subscribeActive);
      }
    }

    function singlesFullBundleRegular() {
      // Full price of a complete N-bag bundle (all single bags are the same price), in cents
      const unit = Number((products.find((p) => p.available) || products[0]).price || 0);
      return unit * BUNDLE_SIZE;
    }

    function updatePricesSingles() {
      const money = (cents) => formatMoney(cents, data.moneyFormat);
      const onetime = Math.round(Number(singlesCfg.onetimePrice || 0) * 100);
      const subscribe = Math.round(Number(singlesCfg.subscribePrice || 0) * 100);
      const fullRegular = singlesFullBundleRegular();

      if (els.subOriginal) els.subOriginal.textContent = SUBSCRIBE_AVAILABLE ? money(fullRegular) : '';
      if (els.subPrice) {
        els.subPrice.textContent = SUBSCRIBE_AVAILABLE ? money(subscribe) : (singlesCfg.subscribeUnavailableText || 'Coming soon');
      }
      if (els.onetimePrice) els.onetimePrice.textContent = money(onetime);

      const complete = totalSelected() === BUNDLE_SIZE;
      const final = state.purchaseType === 'subscribe' ? subscribe : onetime;
      if (els.btnOriginal) {
        els.btnOriginal.textContent = money(fullRegular);
        els.btnOriginal.classList.toggle('hidden', !complete || fullRegular <= final);
      }
      if (els.btnFinal) els.btnFinal.textContent = money(final);
      if (els.cartPricing) els.cartPricing.classList.toggle('hidden', !complete);
    }

    function updatePrices() {
      if (SINGLES) { updatePricesSingles(); return; }
      const total = totalSelected();
      els.stepPrices.forEach((node) => {
        const tierKey = node.getAttribute('data-step-price');
        const tier = data.pricing[tierKey];
        if (!tier) return;
        const value = state.purchaseType === 'subscribe' ? Number(tier.subscribe) : Number(tier.regular);
        node.textContent = `${formatMoney(value * 100, data.moneyFormat)}/ea`;
      });

      const price = activePrice();
      const regular = regularPrice();
      if (els.subOriginal) els.subOriginal.textContent = `${formatMoney(regular * 100, data.moneyFormat)}/ea`;
      // The Subscribe & Save box always shows the subscription price, whichever option is selected
      if (els.subPrice) els.subPrice.textContent = `${formatMoney(unitPrice(true) * 100, data.moneyFormat)}/ea`;
      if (els.onetimePrice) els.onetimePrice.textContent = `${formatMoney(regular * 100, data.moneyFormat)}/ea`;

      const finalTotal = price * total;
      const originalTotal = regular * total;
      if (els.btnOriginal) {
        els.btnOriginal.textContent = formatMoney(originalTotal * 100, data.moneyFormat);
        // No strike-through when there's nothing saved (e.g. one-time purchase)
        els.btnOriginal.classList.toggle('hidden', Math.round(originalTotal * 100) <= Math.round(finalTotal * 100));
      }
      if (els.btnFinal) els.btnFinal.textContent = formatMoney(finalTotal * 100, data.moneyFormat);
      if (els.cartPricing) els.cartPricing.classList.toggle('hidden', total === 0);
    }

    function updateButton() {
      const total = totalSelected();
      if (!els.cartButton || !els.cartButtonText) return;
      const isDisabled = (SINGLES ? total !== BUNDLE_SIZE : total === 0) || state.adding;
      els.cartButton.disabled = isDisabled;
      // Toggled directly via JS rather than Tailwind's disabled: variant — that variant
      // wasn't reliably beating the button's own bg-[#0277B6]/border-[#014465] utility classes
      // in the cascade here, so we swap the classes ourselves instead.
      els.cartButton.classList.toggle('bg-[#0277B6]', !isDisabled);
      els.cartButton.classList.toggle('border-[#014465]', !isDisabled);
      els.cartButton.classList.toggle('shadow-[4px_4px_0px_0px_#014465]', !isDisabled);
      els.cartButton.classList.toggle('text-white', !isDisabled);
      els.cartButton.classList.toggle('hover:opacity-95', !isDisabled);
      els.cartButton.classList.toggle('bg-gray-300', isDisabled);
      els.cartButton.classList.toggle('border-gray-400', isDisabled);
      els.cartButton.classList.toggle('shadow-[4px_4px_0px_0px_#9ca3af]', isDisabled);
      els.cartButton.classList.toggle('text-gray-500', isDisabled);
      els.cartButton.classList.toggle('pointer-events-none', isDisabled);
      if (state.adding) {
        els.cartButtonText.textContent = data.texts.buttonAdding;
        return;
      }
      if (SINGLES) {
        const remaining = BUNDLE_SIZE - total;
        els.cartButtonText.textContent = remaining > 0
          ? `Add ${remaining} more bag${remaining === 1 ? '' : 's'}`
          : data.texts.buttonLabel;
        return;
      }
      els.cartButtonText.textContent = total > 0
        ? `${data.texts.buttonLabel} (${total})`
        : data.texts.buttonEmpty;
    }

    function updateStatus() {
      if (!els.selectionStatus) return;
      const total = totalSelected();
      const remaining = Number(data.config.progressTarget) - total;
      if (remaining <= 0) {
        els.selectionStatus.textContent = data.texts.selectionComplete;
      } else {
        els.selectionStatus.textContent = `${data.texts.selectionPrefix} ${remaining} more bag${remaining === 1 ? '' : 's'}`;
      }
    }

    function refresh() {
      const total = totalSelected();
      const tier = selectedTier();
      renderFlavors();
      updateProgress();
      updatePurchaseBoxes();
      updatePrices();
      updateButton();
      updateStatus();
    }

    async function addToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const total = totalSelected();
      if (state.adding || total === 0) return;
      if (SINGLES && total !== BUNDLE_SIZE) return;
      state.adding = true;
      updateButton();

      let cartState;
      let responseData;

      if (total === 0) {
        state.adding = false;
        updateButton();
        els.cartButtonText.textContent = 'Unable to add bundle';
        return;
      }

      try {
        const currentCartState = await fetchCartState();
        let mergedQuantities;
        if (SINGLES) {
          // A singles bundle is always exactly N bags: replace any earlier one instead of adding to it
          const oldKeys = getBundleCartSnapshot(currentCartState, 'subscribe').keys
            .concat(getBundleCartSnapshot(currentCartState, 'onetime').keys)
            .concat((currentCartState.items || []).filter((item) => BONUS_IDS.has(Number(item.variant_id))).map((item) => item.key));
          await clearExistingBundleItems(oldKeys);
          mergedQuantities = BONUS_COUNT ? splitPaidAndBonus(state.quantities).paid : Object.assign({}, state.quantities);
        } else {
          const existingBundle = getBundleCartSnapshot(currentCartState);
          mergedQuantities = Object.assign({}, existingBundle.quantities);

          Object.keys(state.quantities).forEach((blockId) => {
            mergedQuantities[blockId] = Number(mergedQuantities[blockId] || 0) + Number(state.quantities[blockId] || 0);
          });
        }

        if (sumQuantities(mergedQuantities) === 0) {
          throw new Error('No bundle items available to add');
        }
        const rebuildResult = await rebuildBundleCart(mergedQuantities, state.purchaseType, { openCart: false });
        cartState = rebuildResult.cartState;
        responseData = rebuildResult.responseData;

        if (SINGLES) {
          const bonusItems = BONUS_COUNT ? splitPaidAndBonus(state.quantities).bonusItems : [];
          if (bonusItems.length) {
            const bonusResponse = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: bonusItems })
            });
            if (!bonusResponse.ok) throw new Error('Failed to add bonus bags');
          }
        }

        // Bundle is in the cart - clear the picker so the next bundle starts from scratch
        // instead of showing the previous selection as still "selected".
        if (SINGLES) { prefillSingles(); } else { state.quantities = {}; }

        // Send the shopper straight to checkout instead of opening the cart drawer
        els.cartButtonText.textContent = data.texts.buttonCheckout || 'Going to checkout...';
        // This page's price comes from a discount code (same product as other bundle pages,
        // so an automatic discount can't tell them apart). Set it on the cart itself, not via the
        // /discount/CODE link: that link also leaves a cookie that re-applies the code at checkout
        // even after another bundle page removes it from the cart.
        const root = window.Shopify?.routes?.root || '/';
        const code = SINGLES ? (state.purchaseType === 'subscribe' ? singlesCfg.subscribeCode : singlesCfg.onetimeCode) : '';
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code || '' })
        }).catch(() => {});
        window.location.href = `${root}checkout`;

      } catch (error) {
        console.error('[bundle-builder]', error);
        els.cartButtonText.textContent = /subscription plan/i.test(error.message || '')
          ? 'Subscription unavailable'
          : 'Unable to add bundle';
      } finally {
        setTimeout(() => {
          state.adding = false;
          refresh();
        }, 1500);
      }
    }

    if (els.subscribeBox) {
      els.subscribeBox.addEventListener('click', function () {
        if (!SUBSCRIBE_AVAILABLE) return;
        state.purchaseType = 'subscribe';
        refresh();
      });
    }

    if (els.onetimeBox) {
      els.onetimeBox.addEventListener('click', function () {
        state.purchaseType = 'onetime';
        refresh();
      });
    }

    if (els.nutritionToggles.length > 0) {
      els.nutritionToggles.forEach(toggle => {
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          state.nutritionOpen = !state.nutritionOpen;
          els.nutritionDropdowns.forEach(nd => nd.classList.toggle('hidden', !state.nutritionOpen));
          els.nutritionIcons.forEach(ni => { ni.textContent = state.nutritionOpen ? '–' : '+'; });
          if (!state.nutritionOpen) {
            els.nutritionLists.forEach(nl => nl.classList.add('hidden'));
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-nutrition-toggle]') || event.target.closest('[data-nutrition-dropdown]')) return;
        state.nutritionOpen = false;
        els.nutritionDropdowns.forEach(nd => nd.classList.add('hidden'));
        els.nutritionIcons.forEach(ni => { ni.textContent = '+'; });
      });
    }

    // Flavor-select sub-dropdown inside the nutrition panel
    section.querySelectorAll('[data-nutrition-flavor-btn]').forEach(btn => {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const list = btn.parentElement.querySelector('[data-nutrition-list]');
        if (list) list.classList.toggle('hidden');
      });
    });

    // Plain text FAQ items (shipping / order problem). Scoped to this section: the separate
    // "Have Questions?" FAQ section uses the same data-faq-toggle attribute and binds its own
    // handler, so a page-wide query here would toggle those answers twice (open, then closed).
    section.querySelectorAll('[data-faq-toggle]').forEach(toggle => {
      toggle.addEventListener('click', function () {
        const answer = toggle.parentElement.querySelector('[data-faq-answer]');
        const icon = toggle.querySelector('[data-faq-icon]');
        if (!answer) return;
        const nowHidden = answer.classList.toggle('hidden');
        if (icon) icon.textContent = nowHidden ? '+' : '–';
      });
    });

    if (els.cartButton) {
      els.cartButton.addEventListener('click', addToCart);
    }

    if (els.prevArrow) {
      els.prevArrow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showPreviousImage();
      });
    }

    if (els.nextArrow) {
      els.nextArrow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showNextImage();
      });
    }

    const mainContainer = section.querySelector('.main-image-container');
    if (mainContainer) {
      let startX = 0;
      let startY = 0;
      mainContainer.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].screenX;
        startY = event.changedTouches[0].screenY;
      }, { passive: true });
      mainContainer.addEventListener('touchend', function (event) {
        const diffX = event.changedTouches[0].screenX - startX;
        const diffY = event.changedTouches[0].screenY - startY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) {
            showPreviousImage();
          } else {
            showNextImage();
          }
        }
      }, { passive: true });
    }

    renderGallery();
    renderNutritionList();
    refresh();
    observeMonsterCart();
    bindMonsterCartGroupingEvents();
    bindMonsterCartControls();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-config]').forEach((configNode) => {
      const section = configNode.closest('[data-section-id]');
      if (section) {
        initBundleSection(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
